document.addEventListener("DOMContentLoaded", function() {

  
  // ===========================================================//
           // ========   Menu Drawer  =========//
  // ===========================================================//
  
    var menu_drawer_container = document.querySelector(".menu-drawer-container");
    menu_drawer_container.addEventListener("click", function() {
      if (!menu_drawer_container.hasAttribute('open')) {
        menu_drawer_container.setAttribute('open', '');
      } 
    });
  
    var announcement_close = document.querySelector(".announcement_close");
    if(announcement_close){
      announcement_close.addEventListener("click", function(event) {
          Submenuopen();
          var utility_bar = document.querySelector(".utility-bar");
           utility_bar.style.display = "none";
      });
    }
    
    $(window).on("load", function () {
        Submenuopen();
    });
    function Submenuopen(submenu) {
      // var announcement = document.querySelector(".utility-bar").offsetHeight;
      var header_main = document.querySelector(".header-wrapper").offsetHeight;
      let total_height  =  header_main;
      var submenuElement = document.querySelector(".header__submenu");
      submenuElement.style.top = total_height + "px";
      submenuElement.style.height = 'calc(100vh - ' + total_height + 'px)';
    }

    var announcement = $(".utility-bar").outerHeight();
    var header_main = $(".header-wrapper").outerHeight();
    // var footer_block = $(".footer-block__details-content").outerHeight();
    let drawer_height = announcement + header_main;
  
  if($(window).width() < 600){
       $(".js .menu-drawer").css("height", "calc(100svh - " + drawer_height + "px)");
    }
  else{
      $(".js .menu-drawer").css("height", "calc(100svh - 133px)");
  }
   
    
    // $(".utility-bar .announcement_close").on("click", function () {
    //   announcement = document.querySelector(".utility-bar").offsetHeight;
    //   header_main = document.querySelector(".header-wrapper").offsetHeight;
    //   drawer_height = announcement + header_main;
    //   $(".js .menu-drawer").css("height", "calc(100vh - " + drawer_height + "px)");
    // });
    
    // var header_menu_item = document.querySelector(".header__menu-item");
    // header_menu_item.addEventListener("click", function(event) {
    //     Submenuopen();
    //     var bodyElement = document.body;
    //     bodyElement.classList.toggle("menu_open");
    //     event.stopPropagation(); 
    // });


  var header_menu_hover = document.querySelector("header-menu .menu_hover_line");
  
    header_menu_hover.addEventListener("mouseenter", function() {
        Submenuopen();
        var bodyElement = document.body;
        bodyElement.classList.add("menu_open");
    });
    
    header_menu_hover.addEventListener("mouseleave", function() {
        var bodyElement = document.body;
        bodyElement.classList.remove("menu_open");
    });
    
    var body_click = document.querySelector("body");
    body_click.addEventListener("click", function(event) {
        var menu_contain = document.querySelector(".header__submenu.list-menu");
        if (!menu_contain.contains(event.target)) {
            body_click.classList.remove("menu_open");
        }
    });
});
$(document).ready(function(){

 
  // ===========================================================//
        // ========   View click grid set Desktop  =========//
  // ===========================================================//

     $(document).on("click", ".view_item", function () {
        var siblings = $(this).parent().children();
        siblings.not(this).removeClass('active');
        $(this).addClass('active');
        
        var viewItemText = $(this).text().trim();
        localStorage.setItem("select_col", viewItemText);
        desktop(viewItemText);
        tablet_down(viewItemText);
    });

    function desktop(viewItemText) {
      $('#product-grid').removeClass(function (index, className) {
          return (className.match(/(^|\s)grid--\S*-col-desktop/g) || []).join(' ');
      }).addClass('grid--' + viewItemText.toLowerCase() + '-col-desktop');
    }
    function tablet_down(viewItemText) {
      $('#product-grid').removeClass(function (index, className) {
          return (className.match(/(^|\s)grid--\S*-col-tablet-down/g) || []).join(' ');
      }).addClass(`grid--${viewItemText.toLowerCase()}-col-tablet-down`);
    }
  
    window.onload = function() {
    var viewItemText = localStorage.getItem("select_col");
    if (viewItemText !== null) {
      $(".view_item").each(function(index, element) {
        var itemText = $(element).text();
        if(itemText == viewItemText){
            var siblings = $(this).parent().children();
            siblings.not(this).removeClass('active');
            $(this).addClass('active');
        }
      });
      desktop(viewItemText);
      tablet_down(viewItemText);
    } else {
      
    }
  
  };

  var windowWidth = $(window).width();
  if (windowWidth <= 749) {
      $('.view_item:nth-child(1)').addClass('active');
  } else {
      $('.view_item:nth-child(1)').removeClass('active');
  }
  
  // ===========================================================//
           // ========   cart drawer  =========//
  // ===========================================================//
  
  
  var announcement = document.querySelector(".utility-bar").offsetHeight;
  var header_main = document.querySelector(".header-wrapper").offsetHeight / 2;
  let total_height  = announcement +  header_main;
  var drawer = document.querySelector(".drawer");
  drawer.style.top = total_height + "px";

 
  window.addEventListener("scroll", function() {
      var scrollPosition = window.scrollY;
      if (scrollPosition >= 150) {
          var header_main = document.querySelector(".header-wrapper").offsetHeight / 2;
          var total_height = header_main;
          var drawer = document.querySelector(".drawer");
          drawer.style.top = total_height + "px";
      }else{
        var announcement = document.querySelector(".utility-bar").offsetHeight;
        var header_main = document.querySelector(".header-wrapper").offsetHeight / 2;
        let total_height  = announcement +  header_main;
        var drawer = document.querySelector(".drawer");
        drawer.style.top = total_height + "px";
      }
  });
    // ===========================================================//
           // ========   header scroll css   =========//
  // ===========================================================//
     let announcement_scroll = document.querySelector(".utility-bar").offsetHeight;
     let header_main_scroll = document.querySelector(".header-wrapper").offsetHeight
      var header = $(".scrollheader");
  var pageheight = $(window).height() + 100;
        $(window).scroll(function() {
          var scroll = $(window).scrollTop();
if($(window).height() > pageheight){
          if (scroll >= announcement_scroll ) {
            header.removeClass('scrollheader').addClass("coverheader");
            $("#MainContent").css({'padding-top': header_main_scroll + 'px'});
          } else {
            header.removeClass("coverheader").addClass('scrollheader');
            $("#MainContent").css({'padding-top': 0 + 'px'});
          }
  }
        }); 
  
    
   // ===========================================================//
           // ========   Variant image change on click   =========//
  // ===========================================================//
 
    $(document).on("click", ".facets .facets__heading", function () {
        $(this).parents(".open_filters_item").toggleClass("open_filter");
    });
    $(document).on("click", ".facets .facet-filters__label", function () {
        $(this).parents(".open_filters_item").toggleClass("short_by");
    });
  
    
   // ===========================================================//
           // ========   Header submenu click event  =========//
  // ===========================================================//
  
  $(document).on('click',".header__menu-item",function(){
    $(this).parents(".header__submenu li").siblings(".sub_tile_show").removeClass("sub_tile_show")
    if($(this).parents(".header__submenu li").hasClass("sub_tile_show")){
      $(this).parents(".header__submenu li").removeClass("sub_tile_show")
    }else{
      $(this).parents(".header__submenu li").addClass("sub_tile_show");
    }
  });
  $(document).on('click',".main_drawer_item .first_item_event",function(){
    $(this).parents(".main_drawer_item").siblings(".menu_show").removeClass("menu_show")
    if($(this).parents(".first_item_menu").hasClass("menu_show")){
      $(this).parents(".first_item_menu").removeClass("menu_show")
    }else{
      $(this).parents(".first_item_menu").addClass("menu_show");
    }
  });
  $(document).on('click',".second_item_sub",function(){
    $(this).parents(".menu-drawer__inner-submenu li").siblings(".menu_sub_item").removeClass("menu_sub_item")
    if($(this).parents(".menu-drawer__inner-submenu li").hasClass("menu_sub_item")){
      $(this).parents(".menu-drawer__inner-submenu li").removeClass("menu_sub_item");
    }else{
      $(this).parents(".menu-drawer__inner-submenu li").addClass("menu_sub_item");
    }
  });


   // ===========================================================//
           // ========   Product Page  =========//
  // ===========================================================//
  $(".icon-hamburger").on("click", function () {
      $(this).parents(".header").addClass("menu-opening");
      $(this).parents("body").addClass("open");
  });
  
  $(".icon-close").on("click", function () {
      $(this).parents(".header").removeClass("menu-opening");
      $(this).parents("body").removeClass("open");
  });
    
  $(".size_option span").on("click",function () {
    $(this).parents("").addClass("open_size")
  });

  $(".size_heading svg").on("click",function () {
     $("body").css("overflow", "unset");
     $(".product,.product__info-wrapper").removeClass("open_size");
    $(this).parents("").removeClass("open_size");
   
  });

  // ===========================================================//
           // ========  accordion_list  =========//
  // ===========================================================//
  $(document).on('click',".accordion_list span",function(){
      let $this = $(this);
      $this.parent().siblings().removeClass('active');
      if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.parents().removeClass('active');
          $this.next().slideUp(500);
      } else {
          $this.parent().parent().find('.accordion_list .inner_content').removeClass('show');
          $this.parent().parent().find('.accordion_list .inner_content').slideUp(350);
          $this.next().toggleClass('show');
          $this.parent().toggleClass('active');
          $this.next().slideToggle(500);
      }

      var clickedSpanText = $(this).text();
      if( clickedSpanText =="Payment options"){
        
        if($(this).parents().hasClass('active')){
          $(this).parents(".product__info-wrapper").find("square-placement").show();
          $('.inner_content.show').css('margin-top', '0');
        }else{
          $(this).parents(".product__info-wrapper").find("square-placement").hide();
        }
      }else{
          $(this).parents(".product__info-wrapper").find("square-placement").hide();
        }
      
  });


  $(".main_email_inner svg.close_icon").on("click",function () {
    $(this).parents(".main_email_popup").hide();
    $(this).parents(".main_email_popup").removeClass("active");
    // $(this).parents("body").css("overflow", "inherit");
  });

    // $('.plus-icon').on('click', function() {
    //     var $image = $(this).closest('.product__media').find('img');
    //     $image.trigger('click');
    // });


  $(document).on('click', function(event) {
    if (!$(event.target).closest('.block-991 .header__search').length && !$(event.target).hasClass('onsearch-click')) {
      $('.block-991 .header__search').removeClass('active');
    }
  });

  $('.onsearch-click').click(function(){
       event.stopPropagation(); 
    $('.block-991 .header__search').toggleClass('active');
 });
   $('.header__icon--search').on('click', function() {
         $(this).parents('.header__search').addClass('active');
    });

   $('.header__search .search-modal__content .search_icon').on('click', function() {
        $(this).parents('.header__search').removeClass('active');
    });


   window.onload = function() {
      var mainEmailPopup = document.querySelector('.main_email_popup');
      if (mainEmailPopup) {
          setTimeout(function() {
              mainEmailPopup.style.display = 'block';
               mainEmailPopup.classList.add('active');
          }, 5000); 
      }
  };
  $(document).on('click',".sub-t-vid",function(){
    $(this).parents(".sub-t-container").addClass("show_content")
  });


  setTimeout(function() { 
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  $('.close_icon').click(function () {
      setCookie('hide_popup', true, 5);
      $('.main_email_popup').hide();
      $('.main_email_popup').removeClass('active');
  });
  var value = getCookie('hide_popup');
  if(value == 'true'){
    console.log("value",value)
    $('.main_email_popup').addClass("hide_mail_box");
  }
  }, 6000);



   // When the user scrolls down 50px from the top of the document, resize the header's font size
  window.onscroll = function() {scrollFunction()};
  window.onresize = function() {scrollFunction()};
  
  function scrollFunction() {
  	if (document.documentElement.scrollTop >= 45) {
          
  		document.getElementById("scroll_styles").innerHTML = `
  			
  			/* ==== when scrolled on desktop ==== */
  			@media only screen and (min-width: 768px) {
  				#header {
                  transition: 0.4s;
  				}
                .header__heading-logo {
                  transition: 0.4s;
                  max-width: 65% !important;
  				}
                .header--middle-center a.header__heading-link {
                    padding: 15px 0 0 !important;
                    transition: 0.4s;
                }
  			}
  		`
  	} else {
  		document.getElementById("scroll_styles").innerHTML = `/* no override (allow defaults through again) */`
  	}
  }

  var currentPathname = window.location.pathname;
  // $('.customer_service_content:first-child').addClass('active');
  // $('.tag_title:first-child').addClass('active');
  $(".tag_title").on('click', function() {
    var titleurl = $(this).attr("data_url");
    var titleid = $(this).attr("data-id");
    var newUrl = '/pages/customer-service#' + titleid;
    window.location.href = newUrl;
    $(".tag_title").siblings().removeClass("active");
    $(".tag_title[data-id='" + titleid + "']").addClass("active");
    $(".customer_service_content").siblings().removeClass("active");
    $(".customer_service_content[data-id='" + titleid + "']").addClass("active");
  });
});

 $(window).on('load', function() {
      var fragment = window.location.hash;
      var fragmentWithoutHash = fragment.substring(1);
      // $(".tag_title").siblings().removeClass("active");
      // $(".tag_title[data-id='" + fragmentWithoutHash + "']").addClass("active");
      // $(".customer_service_content").siblings().removeClass("active");
      // $(".customer_service_content[data-id='" + fragmentWithoutHash + "']").addClass("active");
  setTimeout(function(params) {
    $('.customer_service_sec').show();
  },100)      
});
$(window).on('load', function() {
    var fragment = window.location.hash;
    var fragmentWithoutHash = fragment.substring(1);
    $('.customer_service_sec .tab_list .tag_title').each(function() {
      if ($(this).attr('data-id') === fragmentWithoutHash) {
            $(this).addClass('active');
        }
    })
    $('.customer_service_sec .page_content_item .customer_service_content').each(function() {
        if ($(this).attr('data-id') === fragmentWithoutHash) {
              $(this).addClass('active');
        }
    });
  });